import ninegrid from "../index.js";

export class ngContextMenu
{
	#owner;
	#source;
	#items;
	#events;
	#maxLevel;
	#panel;
	
	constructor (params) {
		this.#maxLevel	= 0;
		this.#owner		= params.owner;

		this.#init(params);
	}
	
	openMenu = (x,y) => {
		
		var font = $(this.#panel).css("font");
		var w = 150;
		for (const item of this.#items) {
			w = Math.max(w, ninegrid.measureTextSize(item.name, font).width + 60);
		}

		$(this.#panel).css({
			"width"		: w,
			"top"		: y,
			"left"		: x,
			//"z-index"	: 2,
		});
		
		this.#panel.open();

		if (this.#events && this.#events.show) this.#events.show.call(this, {source : this.#source});
	}
	
	#init = (params) => {

		this.#items = this.#initItems(params.items, 0);
		this.#events = params.events;
		
		this.#panel = $(`<ng-context-menu-panel id="${params.id}"></ng-context-menu-panel>`)[0];
		$(this.#owner.shadowRoot).append($(this.#panel).hide());
		
		this.#panel.init(this.#items);
		
		$("li", this.#panel).on("mousedown", e => {
			
			//e.stopPropagation();
			
			if (params.callback) {
				e.menuId = e.currentTarget.getAttribute("menu-id");
				e.source = this.#source;
				params.callback(e);
			}
			
			$("ng-context-menu-panel", this.#owner.shadowRoot).hide();
		});
	};

	#initItems = (v, lvl) => {

		this.#maxLevel = Math.max(lvl, this.#maxLevel) + 1;
		
		v = this.#object2Array(v);
		
		for (const item of v) {
			item.level = lvl;
			if (item.hasOwnProperty("items")) item.items = this.#initItems(item.items, lvl+1);
		}
		
		return v;
	};
	
	#object2Array = (v) => {
		
		if (Array.isArray(v)) return v;
		
		var arr = [];
		for (const item in v) {
			var o = v[item];
			o.menuId = item;
			arr.push(o);
		}
		
		return arr;
	};
}

class ngContextMenuPanel extends HTMLElement
{
	constructor () {
		super();
	}

	connectedCallback() {
		this.innerHTML = '<ul></ul>';
	};

	init = (items) => {
		var ul = $("ul", this);
		$('li', ul).remove();
		
		this.#appendItems(ul, items);

		//$("li", this).on("touchmove", this.#onMouseOver);
		$("li", this).on("mouseover", this.#onMouseOver);
		
		$("li", this).on("mouseout", e => { ninegrid.j.querySelectorAll(e.currentTarget).removeClass("visible"); });
	};
	
	open = () => {
		$(this).show();
	};
	
	#appendItems = (ul, items) => {

		for (const item of items) {
			
			var className = (item.hasOwnProperty('className') ? item.className : "") + (item.hasOwnProperty('items') ? " submenu" : "");
			var li = $(`<li menu-id='${item.menuId}' id="${item.name}" class="${className.trim()}"><span>${item.name}</span></li>`);
			ul.append(li);
			
			if (item.hasOwnProperty("items")) {
				var child = $('<ul></ul>');
				li.append(child);
				
				this.#appendItems(child, item.items);
			}
		}
	};
	
	#onMouseOver = 	e => {

		ninegrid.j.querySelectorAll(e.currentTarget).addClass("visible");

		var font = $(this).css("font");
		var w = 150;
		$("ul > li:visible > span", e.currentTarget).each((i,el) => {
			w = Math.max(w, ninegrid.measureTextSize($(el).text(), font).width + 60);
		});

		$("ul", e.currentTarget).eq(0).css({
			"width"		: w,
			"top"		: -9,
			"left"		: $(e.currentTarget.closest("ul")).width() - 8,
			"z-index"	: Number($(this).css("z-index")) + 1,
		});
	};
}

if (!customElements.get('ng-context-menu-panel')) {
	customElements.define("ng-context-menu-panel", ngContextMenuPanel);
}